module.exports = __webpack_public_path__ + "img/corporativa-icon.42af174a.png";